<cc-checkbox
  id="{{ field.id }}-hidden"
  [(modelValue)]="field.isHiddenInFormPDFExports"
  (onUpdate)="fieldActionsConfig.hide.onUpdate.emit()"
  labelText="Hide in Form PDF exports"
  labelClass="checkbox-control"
  hostClass="checkbox-control hidden-pdf"
></cc-checkbox>
<cc-checkbox
  *ngIf="fieldActionsConfig.require.isVisible"
  id="{{ field.id }}-required"
  [(modelValue)]="field.isRequired"
  (onUpdate)="fieldActionsConfig.require.onUpdate.emit()"
  labelText="Required"
  labelClass="checkbox-control"
  hostClass="checkbox-control required"
></cc-checkbox>
<cc-field-action type="delete" (onClick)="fieldActionsConfig.delete.onUpdate.emit()"></cc-field-action>
<cc-field-action
  type="clone"
  [disabled]="disabled"
  (onClick)="fieldActionsConfig.clone.onUpdate.emit()"
></cc-field-action>
